/*
 * SPDX-FileCopyrightText: 2022 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { NgModule } from '@angular/core';
import { CmsConfig, I18nConfig, provideConfig } from '@spartacus/core';
import {
  productImageZoomTranslationChunksConfig,
  productImageZoomTranslationsEn,
  productImageZoomTranslationsEs
} from '@spartacus/product/image-zoom/assets';
import {
  PRODUCT_IMAGE_ZOOM_FEATURE,
  ProductImageZoomRootModule,
} from '@spartacus/product/image-zoom/root';
import { CustomProductImageZoomTriggerModule } from '../../custom/cms-components/product/custom-image-zoom/custom-product-image-zoom-trigger/custom-product-image-zoom-trigger.module';
import { CustomProductImageZoomModule } from '../../custom/cms-components/product/custom-image-zoom/custom-product-image-zoom.module';

@NgModule({
  imports: [
    ProductImageZoomRootModule,
    CustomProductImageZoomTriggerModule,
    CustomProductImageZoomModule
  ],
  providers: [
    provideConfig(<CmsConfig>{
      featureModules: {
        [PRODUCT_IMAGE_ZOOM_FEATURE]: {
          module: () =>
            import('@spartacus/product/image-zoom').then(
              (m) => m.ProductImageZoomModule
            ),
        },
      },
    }),
    provideConfig(<I18nConfig>{
      i18n: {
        resources:{
          en:{ productImageZoom: productImageZoomTranslationsEn },
          es:{ productImageZoom: productImageZoomTranslationsEs }
        },
        chunks: productImageZoomTranslationChunksConfig,
      },
    }),
  ],
})
export class ImageZoomFeatureModule { }
